import type { AuthSessionUser } from "./authSession.types";

export const AUTH_ME_RESPONSE_KEY = "auth_me_response";

export function persistSessionUser(data: AuthSessionUser): void {
  const clientId =
    data.client_id ?? data.clientId ?? data.id ?? data.user_id ?? data.userId;
  if (clientId) {
    localStorage.setItem("auth_user_id", String(clientId));
  }
  localStorage.setItem("auth_user", JSON.stringify(data));
  if (data.site_map != null) {
    localStorage.setItem("auth_site_map", String(data.site_map));
  }
}

export function persistAuthMeResponse(fullJson: unknown): void {
  localStorage.setItem(AUTH_ME_RESPONSE_KEY, JSON.stringify(fullJson));
}

export function readCachedAuthMeResponse(): unknown | null {
  try {
    const raw = localStorage.getItem(AUTH_ME_RESPONSE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as unknown;
  } catch {
    return null;
  }
}

export function readCachedSessionUser(): AuthSessionUser | null {
  try {
    const raw = localStorage.getItem("auth_user");
    if (!raw) return null;
    return JSON.parse(raw) as AuthSessionUser;
  } catch {
    return null;
  }
}
